export type TableButtonFace = 'positive' | 'warning' | 'danger' | 'neutral' | 'edit' | 'delete'
